import { render, staticRenderFns } from "./acpm-investigacion-matriz-editar.vue?vue&type=template&id=78801492&"
import script from "./acpm-investigacion-matriz-editar.vue?vue&type=script&lang=js&"
export * from "./acpm-investigacion-matriz-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports